import React from "react";
import { CircleWithBadge } from "../../../advancing/components/circlewithbadge";

interface Props {
  amountUnseenMesssages: number
}

const UnseenMessagesBadge = (props: Props) => {
  const { amountUnseenMesssages } = props;
  return <CircleWithBadge icon="message" count={amountUnseenMesssages} badge="alert" title={amountUnseenMesssages + " " + RESX.Advancing.MessagesWaiting} />;
};

export default UnseenMessagesBadge;